var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepartmentMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M456.348 380.553v-52.205c0-27.618-22.469-50.087-50.087-50.087H272.696v-45.719c56.56-8.126 100.174-56.898 100.174-115.672C372.87 52.428 320.442 0 256 0S139.13 52.428 139.13 116.87c0 58.774 43.613 107.546 100.174 115.672v45.719H105.739c-27.618 0-50.087 22.469-50.087 50.087v52.205c-28.77 7.434-50.087 33.604-50.087 64.664C5.565 482.041 35.524 512 72.348 512s66.783-29.959 66.783-66.783c0-31.061-21.317-57.23-50.087-64.664v-52.205c0-9.206 7.49-16.696 16.696-16.696h133.565v68.896c-28.771 7.432-50.087 33.608-50.087 64.669C189.217 482.041 219.176 512 256 512s66.783-29.959 66.783-66.783c0-31.061-21.316-57.237-50.087-64.669v-68.896h133.565c9.206 0 16.696 7.49 16.696 16.696v52.205c-28.77 7.433-50.087 33.604-50.087 64.664 0 36.824 29.959 66.783 66.783 66.783s66.783-29.959 66.783-66.783c-.001-31.06-21.318-57.23-50.088-64.664zm-350.609 64.664c0 18.412-14.979 33.391-33.391 33.391s-33.391-14.979-33.391-33.391 14.979-33.391 33.391-33.391 33.391 14.979 33.391 33.391zm183.652 0c0 18.412-14.979 33.391-33.391 33.391s-33.391-14.979-33.391-33.391 14.979-33.391 33.391-33.391 33.391 14.979 33.391 33.391zM256 200.348c-46.03 0-83.478-37.448-83.478-83.478S209.97 33.391 256 33.391s83.478 37.448 83.478 83.478S302.03 200.348 256 200.348zm183.652 278.261c-18.412 0-33.391-14.979-33.391-33.391s14.979-33.391 33.391-33.391 33.391 14.979 33.391 33.391c0 18.411-14.979 33.391-33.391 33.391z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartmentMaster);
export default __webpack_public_path__ + "static/media/department-master.8ecaae6e7a5ff01336ef5cdbceddee28.svg";
export { ForwardRef as ReactComponent };